import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  tweetContent?: string;
  tweetUrl?: string;
  profileName?: string;
  profileUsername?: string;
  postedAt?: string;
  screenshotUrl?: string;
}

// The blockquote is what widgets.js upgrades into a live tweet; its contents show only when that does not happen.
const Twitter = ({
  anchorId,
  tweetContent,
  tweetUrl,
  profileName,
  profileUsername,
  postedAt,
  screenshotUrl,
}: Props) => {
  const { utmParams } = usePostContentContext();
  const tweetUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(tweetUrl), utmParams);

  const renderFallback = () => {
    if (profileName) {
      return (
        <>
          {tweetContent && <p dangerouslySetInnerHTML={{ __html: tweetContent }} />}
          <a href={tweetUrlWithUTMParams}>
            <p>
              &mdash; {profileName} ({profileUsername})
              <br />
              {postedAt}
            </p>
          </a>
        </>
      );
    }

    if (screenshotUrl) {
      return (
        <a href={tweetUrlWithUTMParams} target="_blank" rel="noreferrer">
          <img src={screenshotUrl} alt="Tweet screenshot" className="block w-full" />
        </a>
      );
    }

    return (
      <a href={tweetUrlWithUTMParams} target="_blank" rel="noreferrer">
        {tweetUrl}
      </a>
    );
  };

  return (
    <div className="py-2">
      <div className="twitter-wrapper mx-auto max-w-[520px]" id={anchorId}>
        <blockquote className="twitter-tweet text-center">{renderFallback()}</blockquote>
      </div>
    </div>
  );
};

export { Twitter };
